import { Button, Menu, Typography } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import makeStyles from '@material-ui/core/styles/makeStyles';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import GcpBox from '../gcp-box';
import GcpRecurringStatus from '../gcp-recurring-status';
import useViewModel from './viewmodel';

const useStyles = makeStyles((theme) => ({
  container: {
    margin: 0,
    '& > .MuiButton-root': {
      width: '100%',
    },
  },
  menu: {
    marginTop: '8px',
  },
  icon: {
    marginLeft: 'auto',
    display: 'flex',
    alignItems: 'center',
  },
  grayColor: {
    color: theme.palette.common.silver,
  },
  disabledButton: {
    boxShadow: 'none',
    '&.Mui-disabled': {
      backgroundColor: '#E0E0E0 !important',
      color: '#BDBDBD !important',
      border: '1px solid #00000040 !important',
    },
  },
}));

export interface GcpRecurringSelectStatusProps {
  value: string;
  disabled?: boolean;
  onChange: (value: string) => void;
}

export const statusList = [
  'all',
  'upload_processing',
  'rejected',
  'failed_to_upload',
  'pending',
  'partial',
  'failed_to_approve',
  'in_queue',
  'ongoing',
  'failed',
  'completed',
];

// TODO
export const statusToBE = {
  upload_processing: 'Upload processing',
  rejected: 'Upload rejected',
  failed_to_upload: 'Failed to upload',
  pending: 'Pending approval',
  partial: 'Partial approved',
  failed_to_approve: 'Failed to approve',
  in_queue: 'In queue',
  ongoing: 'Ongoing processing',
  failed: 'Processing failed',
  completed: 'Processing completed',
};

const GcpRecurringSelectStatus: FC<GcpRecurringSelectStatusProps> = (props) => {
  const classes = useStyles(props);
  const { t } = useTranslation();
  const { disabled, value, onChange } = props;
  const { status, anchorEl, handleClick, handleClose, handleChange } =
    useViewModel({
      value,
      onChange,
      disabled,
    });

  return (
    <GcpBox
      alignItems="center"
      className={classes.container}
      display="flex"
      justifyContent="center"
    >
      <Button
        className={classes.disabledButton}
        disabled={disabled}
        variant="outlined"
        onClick={handleClick}
      >
        {status !== statusList[0] && (
          <div style={{ marginRight: '8px' }}>
            <GcpRecurringStatus
              size={8}
              status={statusToBE[status.toLowerCase()].toLowerCase()}
            />
          </div>
        )}
        <div className={status === statusList[0] ? classes.grayColor : ''}>
          {status === ''
            ? t(`payment_file.upload_logs.status.all`)
            : t(`payment_file.upload_logs.status.${status}`)}
        </div>
        <div className={classes.icon}>
          <svg
            fill="none"
            height="17"
            viewBox="0 0 16 17"
            width="16"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M14.7628 4.24207H13.4235C13.3324 4.24207 13.2467 4.28671 13.1931 4.35992L8.11993 11.3528L3.04671 4.35992C2.99314 4.28671 2.90742 4.24207 2.81635 4.24207H1.47707C1.361 4.24207 1.29314 4.37421 1.361 4.46885L7.65743 13.1492C7.886 13.4635 8.35385 13.4635 8.58064 13.1492L14.8771 4.46885C14.9467 4.37421 14.8789 4.24207 14.7628 4.24207Z"
              fill="#BDBDBD"
            />
          </svg>
        </div>
      </Button>
      <Menu
        keepMounted
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        className={classes.menu}
        elevation={1}
        getContentAnchorEl={null}
        id="customized-menu"
        open={Boolean(anchorEl)}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        onClose={handleClose}
      >
        {statusList.map((item) => (
          <MenuItem key={item} onClick={() => handleChange(item)}>
            <GcpBox alignItems="center" display="flex" gap={1}>
              {item !== statusList[0] && (
                <GcpRecurringStatus
                  size={8}
                  status={statusToBE[item.toLowerCase()].toLowerCase()}
                />
              )}
              <Typography>
                {t(`payment_file.upload_logs.status.${item}`)}
              </Typography>
            </GcpBox>
          </MenuItem>
        ))}
      </Menu>
    </GcpBox>
  );
};

export default GcpRecurringSelectStatus;
